import React, { useState, useEffect } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  Select,
  Collapse,
  InputNumber,
  DatePicker, Typography,
} from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "./Helper";
import moment from "moment";

const CreditReportTableFilter = (props) => {
  const [form] = Form.useForm();

  const [bankSelect, setBankSelect] = useState({
    data: [],
    loading: false,
  });
  const [accountNameSelect, setAccountNameSelect] = useState({
    data: [],
    loading: false,
  });
  const [ibanSelect, setIbanSelect] = useState({
    data: [],
    loading: false,
  });
  const [accountSelect, setAccountSelect] = useState({
    data: [],
    loading: false,
  });
  const [currencySelect, setCurrencySelect] = useState({
    data: [],
    loading: true,
  });


  useEffect(() => {
    getBanks();
    getAccountNames();
    getCurrencies();

  }, []);

  useEffect(() => {
    if (props.data) {

      if (props.data.filterStartDate && props.data.filterEndDate) {
        props.data.transactionDateRange = [
          moment(props.data.filterStartDate),
          moment(props.data.filterEndDate),
        ];
      }
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const getBanks = () => {
    setBankSelect({
      ...bankSelect,
      loading: true,
    });
    RequestHandler.get(`/Bank/GetFilterBank`).then((response) => {
      setBankSelect({
        data: response,
        loading: false,
      });
    });
  };
  const getAccountNames = () => {
    setAccountNameSelect({
      ...accountNameSelect,
      loading: true,
    });
    RequestHandler.get(
      `/TenantAccount?$select=id,name&$filter=name ne null and name ne ''`
    ).then((res) => {
      const formattedValues = Array.from(
        new Map(res.value.map((item) => [item.name, item])).values()
      ).map((item) => ({
        name: item.name,
        id: item.id,
      }));
      setAccountNameSelect({ data: formattedValues, loading: false });
    });
  };
  const getCurrencies = () => {
    setCurrencySelect({
      ...currencySelect,
      loading: true,
    });
    RequestHandler.get(`/Currency/GetByBankAccounts?$select=id,code`).then(
      (response) => {
        setCurrencySelect({
          data: response,
          loading: false,
        });
      }
    );
  };

  const onIbanSearch = (value) => {
    if (value.length >= 5) {
      setIbanSelect({ data: [], loading: true });
      RequestHandler.get(
        `/TenantAccount?$select=iban&$filter=${odata.contains("iban", value)}`
      ).then((res) => {
        const formattedIbans = Array.from(
          new Set(res.value.map((item) => item.iban))
        ).map((iban) => ({ iban }));
        setIbanSelect({ data: formattedIbans, loading: false });
      });
    } else {
      setIbanSelect({ data: [], loading: false });
    }
  };
  const onAccountSearch = (value) => {
    if (value.length >= 2) {
      setAccountSelect({ data: [], loading: true });
      RequestHandler.get(
        `/TenantAccount?$select=accountNumber&$filter=${odata.contains(
          "accountNumber",
          value
        )}`
      ).then((res) => {
        setAccountSelect({ data: res.value, loading: false });
      });
    } else {
      setAccountSelect({ data: [], loading: false });
    }
  };

  const onFinish = (values) => {
    {
      let query = "";
      const conditions = [];

      if (values.bankId) {
        conditions.push(`bankId eq ${values.bankId}`);
      }

      if (values.tenantIban) {
        conditions.push(`accountNumber eq '${values.tenantIban}'`);
      }


      if (values.currencyId) {
        conditions.push(`currencyId eq ${values.currencyId}`);
      }

      if (values.transactionDateRange) {
        const [startDate, endDate] = values.transactionDateRange;

        props.setStartDate(startDate.format("YYYY-MM-DD"));
        props.setEndDate(endDate.format("YYYY-MM-DD"));
          conditions.push(`date(filterStartDate) ge ${startDate.format("YYYY-MM-DD")}`);
          conditions.push(`date(filterEndDate) lt ${endDate.format("YYYY-MM-DD")}`);
      }


      if (values.tenantAccountNumber) {
        let filterText = odata.contains("accountNumber", values.tenantAccountNumber);
        conditions.push(`${filterText}`);
      }


      if (values.tenantAccountName) {
        conditions.push(
          odata.contains("accountName", values.tenantAccountName)
        );
      }

      if(values.dayCount) {
        conditions.push(`dayCount eq ${values.dayCount}`);
      }


      if (conditions.length !== 0) {
        query = conditions.join(" and ");
      }

      if (props.onFinishFilter) props.onFinishFilter(query, values);
    }
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };
  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız."
           extra={
             <Typography>
               <Typography.Paragraph
                 style={{
                   marginBottom: 0,
                   fontSize: "80%",
                 }}
                 type="secondary"
               >
                 Varsayılan olarak son 1 aylık veriye göre oluşturulmuştur.
               </Typography.Paragraph>
             </Typography>
           }
            >
            <Form
              name="filter"
              form={form}
              initialValues={{
                remember: true
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="bankId" label="Banka :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Tümü"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={bankSelect.loading}
                    >
                      {bankSelect.data.map((item) => (
                        <Select.Option key={item.text} value={item.text}>
                          {item.value}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="tenantIban" label="Iban :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="En az 5 rakam giriniz.."
                      onSearch={onIbanSearch}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        option.code
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={ibanSelect.loading}
                    >
                      {ibanSelect.data.map((item) => (
                        <Select.Option
                          key={item.iban}
                          value={item.iban}
                          code={item.iban}
                        >
                          {item.iban}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="currencyId" label="Para Birimi :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Tümü"
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={currencySelect.loading}
                    >
                      {currencySelect.data.map(({ id, code }) => (
                        <Select.Option key={id} value={`${id}`}>
                          {code}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="transactionDateRange" label="Tarih :">
                    <DatePicker.RangePicker style={{ width: "100%" }} format="DD.MM.YYYY" allowClear={false} />
                  </Form.Item>
                </Col>


                <Col xs={24} md={12} lg={6}>
                  <Form.Item
                    name="tenantAccountNumber"
                    label="Hesap Numarası :"
                  >
                    <Select
                      allowClear
                      showSearch
                      placeholder="En az 2 rakam giriniz.."
                      onSearch={onAccountSearch}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        option.code
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={accountSelect.loading}
                    >
                      {accountSelect.data.map((item) => (
                        <Select.Option
                          key={item.accountNumber}
                          value={item.accountNumber}
                          code={item.accountNumber}
                        >
                          {item.accountNumber}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>



                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="tenantAccountName" label="Hesap Adı :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Tümü"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={accountNameSelect.loading}
                    >
                      {accountNameSelect.data.map((item) => (
                        <Select.Option key={item.id} value={item.name}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>


                  <Col xs={24} md={12} lg={6}>
                  <Form.Item name="dayCount" label="KMH Kullanım Sayısı :">
                    <Input allowClear />
                  </Form.Item>
                </Col>
              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default CreditReportTableFilter;
